import { Component, model, input } from '@angular/core';

@Component({
  selector: 'mbp-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss',
  imports: []
})
export class CheckboxComponent {
  checked = model<boolean>(false);
  disabled = input<boolean>(false);
  ariaLabel = input<string>('');

  protected onCheckboxChange(event: Event): void {
    event.stopPropagation();
    const target = event.target as HTMLInputElement;
    this.checked.set(target.checked);
  }
}
